import { createFileRoute } from "@tanstack/react-router";

import { useMe } from "../features/auth/session";
import { CampaignActivity } from "../features/autopilot/CampaignActivity";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/campaigns/$campaignId/activity")({
  component: TabRoute,
});

function TabRoute() {
  const t = useT();
  const me = useMe();
  const { campaignId } = Route.useParams();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return <CampaignActivity campaignId={campaignId} />;
}
